export function toIsoDate(d) {
	const y = d.getFullYear()
	const m = String(d.getMonth() + 1).padStart(2, "0")
	const day = String(d.getDate()).padStart(2, "0")
	return `${y}-${m}-${day}`
}

export function numeroSemanaIso(date) {
	const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
	const dayNum = d.getUTCDay() || 7
	d.setUTCDate(d.getUTCDate() + 4 - dayNum)
	const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
	return Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
}

export function semanaAtual(ref = new Date()) {
	const d = new Date(ref.getFullYear(), ref.getMonth(), ref.getDate())
	const dow = d.getDay()
	const mondayOffset = dow === 0 ? -6 : 1 - dow
	const inicio = new Date(d)
	inicio.setDate(d.getDate() + mondayOffset)
	const fim = new Date(inicio)
	fim.setDate(inicio.getDate() + 6)
	return {
		inicio: toIsoDate(inicio),
		fim: toIsoDate(fim),
		numero: numeroSemanaIso(d),
	}
}

const MESES = [
	"janeiro", "fevereiro", "março", "abril", "maio", "junho",
	"julho", "agosto", "setembro", "outubro", "novembro", "dezembro",
]

export function opcoesMeses(ref = new Date(), qtde = 6) {
	const out = []
	for (let i = 0; i < qtde; i++) {
		const d = new Date(ref.getFullYear(), ref.getMonth() - i, 1)
		const y = d.getFullYear()
		const m = d.getMonth()
		const ultimo = new Date(y, m + 1, 0)
		out.push({
			value: `${y}-${String(m + 1).padStart(2, "0")}`,
			label: MESES[m],
			inicio: toIsoDate(d),
			fim: toIsoDate(ultimo),
			mesAtual: i === 0,
		})
	}
	return out
}

export function formatarMoeda(valor) {
	return new Intl.NumberFormat("pt-BR", {
		style: "currency",
		currency: "BRL",
	}).format(Number(valor) || 0)
}

export function valorServicoRelatorio(servico) {
	const bruto =
		servico?.valorGanhoProf ??
		servico?.["s.valorProfissional"] ??
		servico?.valorProfissional ??
		servico?.["s.valor"] ??
		servico?.valor ??
		0
	return Number(bruto) || 0
}
